import React from "react";
import { useSelector } from "react-redux";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CardGraph from "../../components/CardGraph/CardGraph";
import { GraphsWrapper } from "./styles";
import "./styles.css";
import { PricesFilters } from "views/PricesSection/PricesFilters";

const options = {
  maintainAspectRatio: false,
  scales: {
    x: {
      offset: true,
    },
  },
  plugins: {
    datalabels: {
      color: "black",
      align: "end",
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
};

const PricesGraph = () => {
  const graphs = useSelector((state) => state.pricesSection.graphs);

  return (
    <>
      <div style={{ marginTop: 16 }}>
        <PricesFilters />
      </div>
      {graphs &&
        graphs.map((graph, index) => (
          <React.Fragment key={`companie-${index}`}>
            {graph.stations.map((station) => (
              <GraphsWrapper key={`${station.name}-${index}`}>
                <CardGraph
                  isVertical
                  height={300}
                  title={`${station.name}`}
                  data={station.correlation}
                  plugins={[ChartDataLabels]}
                  options={options}
                />
              </GraphsWrapper>
            ))}
          </React.Fragment>
        ))}
    </>
  );
};

export default PricesGraph;
